import React, {useState, useEffect} from 'react';
import Main from './Main';
import Axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt, faUser, faCircle, faEdit,faPlusSquare } from '@fortawesome/free-regular-svg-icons';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import Loading from '../componentes/Loading';
import { v4 as uuidv4 } from 'uuid';
import Swal from 'sweetalert2';
import { Form } from 'formik';
import {
    Spinner, Typography,Button,Badge
} from "@material-tailwind/react";

export default function Logs({finalizarSeleccion}){

    const [buscando,setBuscando]=useState(false)
    const [huboError,setHuboError]=useState(false)
    const [logs,setLogs]=useState([]);
    const [reportes,setReportes]=useState([]);

    useEffect(()=>{
       
        buscarLogs()
        buscarReportesScripts()
    },[])


    const abrirArchivo = async (nombre,ruta) => {

    /* ¿Por qué este flujo? Por cuestiones de seguridad ahora la carpeta /logs no está accesible entonces no se pueden descargar directamente archivos desde el navegador
    1. Necesitamos enviar el JWT (Axios) para que el backend autorice la descarga.
    2. El navegador recibe los datos en RAM (Blob) pero no sabe "guardarlos" solos.
    3. Creamos una URL temporal y un link invisible para forzar la descarga al disco.
    */

        try {
            // 1. PETICIÓN AL BACKEND
            const response = await Axios.get(
                `${ruta}/${nombre}`, 
                { responseType: 'blob' }                      // Indica a Axios que reciba datos binarios, no JSON
            );

            // 2. PROCESAMIENTO EN MEMORIA RAM
            const blob = new Blob([response.data]);           // Convierte los datos crudos en un objeto de archivo JS
            const url = window.URL.createObjectURL(blob);     // Crea una ruta temporal (link) que apunta a esa RAM

            // 3. SIMULACIÓN DE DESCARGA EN EL NAVEGADOR
            const a = document.createElement('a');            // Crea un elemento <a> que nunca se verá en pantalla
            a.href = url;                                     // Le asigna la ruta temporal como destino
            a.download = nombre;                              // Fuerza al navegador a descargar en vez de navegar
            document.body.appendChild(a);                     // Lo inserta al DOM un segundo para que sea "clickeable"
            a.click();                                        // Dispara la descarga automáticamente

            // 4. LIMPIEZA (IMPORTANTE PARA EL RENDIMIENTO)
            a.remove();                                       // Elimina el link invisible del HTML
            window.URL.revokeObjectURL(url);                  // Libera la memoria RAM liberando la URL temporal

        } catch (err) {
            Swal.fire({
                icon: 'error',
                title: 'No se pudo descargar el archivo',
                text: err.message                             // Muestra el error real si falla la red o el permiso
            });
        }
    };


     const buscarLogs = async ()=>{
        setBuscando(true)
        try{
             const {data}= await Axios.get('/api/tablasgenerales/logs')
     
             setLogs(data.documentos)
             setBuscando(false)
         }catch(err){
             console.log(err.response.data)
             setBuscando(false)
             setHuboError(true)
         }
     }     
     
      const buscarReportesScripts = async ()=>{
        setBuscando(true)
        try{
             const {data}= await Axios.get('/api/tablasgenerales/reportes-jobs')
     
             setReportes(data?.documentos || [])
             setBuscando(false)
         }catch(err){
             console.log(err.response.data)
             setBuscando(false)
             setHuboError(true)
         }
     }     

    const buscarJobs = async ()=>{
        try{
             const {data}= await Axios.get('/api/tablasgenerales/verjobs')
     
             console.log(data)
         }catch(err){
             console.log(err.response.data)
         }
    }     

    const dispararJob = async ()=>{
        try{
             const {data}= await Axios.get('/api/utilidades/triggerjob/ingresos/pablo')
     
             console.log(data)
         }catch(err){
             console.log(err.response.data)
        }    
    }


    if (huboError){
        return <Main center><span>Se produjo un error al cargar los datos para esta vista</span></Main>
    }

    if (buscando){
        return <Main alinear center><div><Loading/><span className="cargando">Buscando logs...</span></div></Main>
    };

    if(logs.length>0){
        return (<Main center>
            <Typography
                variant="small"
                color="gray"
                className="flex items-center justify-center gap-2 font-semibold text-black text-[20px] mb-4 mt-4"
            >
                Estos archivos solo se descargan de manera segura con un usuario autenticado            
            </Typography>
            <Typography variant="h6" align="center" color="primary" fontWeight="bold">
                    Logs generales uadadmin
            </Typography>
            <button onClick={()=>buscarJobs()}>Ver jobs</button>
            <button onClick={()=>dispararJob()}>Disparar job</button>


            <div className="flex justify-center p-2 mt-4">
                    {logs.length > 0 && <>
                        <table>
                            <tbody>
                                {logs.map(item=><tr className="h-16">
                                    <td>
                                        <button
                                        onClick={()=>abrirArchivo(item.nombre,'/api/tablasgenerales/logs/descargar')}
                                        >
                                        {item.nombre} 
                                        </button>
                                    </td>
                                    {/* <td><a target="_blank" className="ml-2 text-large color-black" href={item.ruta}>{item.nombre}</a></td> */}
                                    
                                    <td>{item.fecha}</td>
                                </tr>)}
                            </tbody>
                        </table>
                    </>}
            </div>
            <Typography variant="h6" align="center" color="primary" fontWeight="bold">
                    Reportes de jobs
            </Typography>
            <div className="flex justify-center p-2 mt-4">
                    {reportes.length > 0 && <>
                        <table>
                            <tbody>
                                {reportes.map(item=><tr className="h-16">
                                    <td>
                                        <button
                                        onClick={()=>abrirArchivo(item.nombre,'/api/tablasgenerales/reportes-jobs/descargar')}
                                        >
                                        {item.nombre} 
                                        </button>
                                    </td>
                                    {/* <td><a target="_blank" className="ml-2 text-large color-black" href={item.ruta}>{item.nombre}</a></td> */}
                                    
                                    <td>{item.fecha}</td>
                                </tr>)}
                            </tbody>
                        </table>
                    </>}
            </div>            
            </Main>
        )
    }else{
        return <h1>No hay archivos</h1>
    }
}

const Archivo = ({handleChangeFile})=>{
    const [archivo,setArchivo] = useState(null)

    function    handleChangeFile(e){
        setArchivo(e.target.files[0])
    }

    const grabarDatos = async (values)=>{

        if (!archivo){
            alert('Falta archivo')
            return 
        }
        const data = new FormData();
    
        data.append('adjunto', archivo);
   
  
    
        let mensaje_html = `<p>El mensaje se envió correctamente</p>`
    
        try{
    
            const respuesta = await Axios.post('/api/tablasgenerales/enviarmail_test',
                        data,
                        {headers: { 'Content-Type': 'multipart/form-data' }}        
            )
            
    
        }catch(err){    
    
            let mensaje_html_error;
    
            alert(err)
    
    
            Swal.fire({
                html:mensaje_html_error,
                icon: 'warning',
                confirmButtonColor: '#3085d6',
            })   
        
        }
       
    
    }

    return  <div className="flex f-col">
    <label className="Form__labels__abmcursos_corto" htmlFor="abm-adjunto">Archivo adjunto (pdf o imágenes hasta 5 MB)</label>
    <input 
        type="file" 
        name="adjunto" 
//        accept="application/pdf,image/x-png,image/jpeg"
        accept="application/pdf"
        onChange={(e)=>handleChangeFile(e)}
        className='input-cvalor'
        id="abm-adjunto"/>
        <button onClick={grabarDatos}>Enviar</button>
</div>
}